export const LogoMark = ({ className = "h-9 w-auto" }) => (
  <svg viewBox="0 0 104 44" className={className} fill="none" aria-hidden="true">
    <g fill="#D4AF37">
      <polygon points="2,40 14,4 21,4 9,40" />
      <polygon points="16,40 28,4 35,4 23,40" />
      <polygon points="30,40 42,4 49,4 37,40" />
    </g>
    <path d="M50 40 L58 4 H66 L76 24 L86 4 H94 L100 40 H92 L89 19 L79 40 H73 L63 19 L60 40 Z" fill="#ffffff" />
  </svg>
);

export const Logo = () => (
  <a href="/" data-testid="brand-logo" className="group flex items-center gap-3">
    <LogoMark className="h-8 w-auto transition-transform duration-500 group-hover:-skew-x-6" />
    <span className="font-display text-2xl tracking-[0.18em] text-white">
      MOTOR <span className="text-[#D4AF37]">SELECT</span>
    </span>
  </a>
);
